// 首页部分
export const flowHomeZH = {
  flowHome1: '重点',
  flowHome2: '推荐',
  flowHome3: '学术研习 共同进步',
  flowHome4: '报名时间',
  flowHome5: 'Y年M月D日',
  flowHome6: '报名条件',
  flowHome7: '财经商业',
  flowHome8: '生命健康',
  flowHome9: '通识学术',
  flowHome10: '人文社科',
  flowHome11: '科学工程',
  flowHome12: '智慧领导力',
  flowHome13: '报名中',
  flowHome14: 'SKT集团旗下活动',
  flowHome15: '学生活动',
  flowHome16: '其它',
  flowHome17: '素养研习活动品牌',
  flowHome18: '覆盖全国一二线城市',
  flowHome19: '合作知名国际学校',
  flowHome20: '服务全国菁英学生',
  flowHome21: '来自Bloom后台活动参与数据',
  flowHome22: '打破成长边界，',
  flowHome23: '培养面向21世纪的核心素养',
  flowHome24: 'Ta们在这里看见世界，也看见了自己的未来',
  flowHome25: '录取学校',
  flowHome26: '开启社会化学习，',
  flowHome27: '解决真实世界的难题',
  flowHome28: '结识榜样朋辈，加入全国同好学术圈',
  flowHome29: '团队领导力培养，提供多元成长机会',
  flowHome30: '如何参与',
  flowHome31: '我们的活动',
  flowHome32: '简单四步 开启精彩',
  flowHome33: '我要参与活动',
  flowHome34: '社会化学习平台',
  flowHome35: '自 2019 年起，SKT 全新推出自主研发的社会化学习线上研习平台——Bloom，旨在为学生、学习小组、学校、评委、教练、活动主办方提供社会化协作学习的解决方案，带来线上线下融合的学习体验，搭建全国优秀学子的交流平台，并链接学术导师与行业专家，探索前沿学术成果。提供优质素养能力研习课程，助力学生高效完成团队合作学习、项目制学习和探究性学习等社会实践项目。',
  flowHome36: '体验社会化学习，量身定制学习计划',
  flowHome37: '海量学习资源，最全的知识库',
  flowHome38: '在线学习系统，支持测试、练习、自测',
  flowHome39: '与超级学霸互动，结识高能量同行者',
  flowHome40: '汇集',
  flowHome41: '全球学术资源',
  flowHome42: '学术研习项目被世界知名高校高度认可',
  flowHome43: '打破边界，实现千万学子的生命绽放',
  flowHome44: '官方公众号',
  flowHome45: '粤ICP备2022127116号',
  flowHome46: '声明：学生可通过自学和团队研习参与SKT旗下各项素养研习社活动，各活动仅提供必要的学术支持和平台支持，不提供任何性质的培训服务。各活动仅对学生研习过程进行记录、对活动结果进行综合性评价，不提供任何奖项及荣誉认定。如参与学生有海外升学认证需求，可自行通过独立第三方认证机构CP21（21世纪人才标准联盟），基于学生在SKT各项素养研习社中的综合评价成果，根据相关权威认证伙伴的学术标准，申请进行成绩转化学术荣誉认定。学术荣誉认定成果与本系列素养研习活动无关，仅适用于学生海外升学自主认证。SKT旗下各项活动均为自主招收参与者，不与各学校联合招生。',
  flowHome47: 'bloom活动平台，发现好玩有趣的活动，有趣的人',
  flowHome48: '预告',
  flowHome49: '距离开播开始还有：',
  flowHome50: '直播时间',
  flowHome51: '查看更多直播',
  flowHome52: '直播中',
  flowHome53: '合作品牌',
  flowHome54: '汇集全球学术资源',
  flowHome55: '成长印记',
  flowHome56: '打破学科边界，解决真实世界的难题',
  flowHome57: '学生们怎么说',
  flowHome58: 'Ta们在这里看见世界，也看见了未来',
  flowHome59: '今日热门',
  flowHome60: '能力提升计划',
  flowHome61: '查看更多',
  flowHome62: '推荐活动',
  flowHome63: '数万中学生的选择',
  flowHome64: '已报名的活动',
  flowHome65: ' ©Copyright 绽放芯知 版权所有 Powered by 绽放芯知',
  flowHome66: '社会化学习平台',
  flowHome67: '全部直播',
  flowHome68: '开播时间',
  flowHome69: 'SKT活动',
  flowHome70: '推荐项目',
  flowHome71: 'Mary',
  flowHome72: '“第一次写工程笔记，第一次做公众号，第一次设计车壳和海报，第一次写商业计划书等等都是在NSL 里面完成的。从完全不懂到熟能生巧，NSL使我明白即使这是一个我从未涉及的领域，我依旧可以 nail it。它让我成为了一个敢于尝试的人。我在高中做了许多对申请有帮助的尝试，这些尝试的勇气归功于NSL。”',
  flowHome73: '加州大学伯克利分校',
  flowHome74: '活动经历：SKT-NSL, SKT-HOSA, SKT-SIC',
  flowHome75: '孟思成',
  flowHome76: '“也许表面看BPA决定成绩的只有比拼时那短短的一小时，但于我来说，为了备战学习商科知识和技巧的漫长过程更让我受益匪浅。荣誉本身并不重要，重要的是在过程中我真正学会了如何把商业知识应用到实际中。比如，在夏校中能够积极踊跃回答问题并提出解决思路，就得益于在BPA全国站学到的知识。”',
  flowHome77: 'BPA 2023全球站高中组Management, Marketing and Human Resources Concepts 参与者',
  flowHome78: '石小异',
  flowHome79: '“SKT-HOSA给了我两年难忘的回忆和个人成长，我从一个仅仅对生物感兴趣的学生变成了一个立志要成为医疗工作者的医学预科生（Pre-Med）,逐渐找到了自己的职业目标和未来方向。HOSA不仅是一个学术研习活动，更是一个温馨的社区，也是一个启迪医学梦想的平台。”',
  flowHome80: '加州大学伯克利分校',
  flowHome81: '活动经历：SKT-HOSA',
  flowHome82: '肖之晗',
  flowHome83: '“NEC把我和来自五湖四海的经济战友们团聚到了一起。起初，我以为NEC只是为我提供了扩展经济知识的一个平台，后来经历过申请季才发现，在NEC活动中认识的那群小伙伴何尝不是在我迷茫与焦虑中宝贵的陪伴。”',
  flowHome84: '香港大学 剑桥大学',
  flowHome85: '国外大学申请的软实力主要体现在活动、荣誉、以及文书上面，我在SIC的这段投资经历可以放在活动上，SIC中团队合作、领导力，以及点点滴滴从中学到的东西亦可以描写成一篇文书，从而打动招生官。参与SIC能带给我的除了简历上的提升，更重要的是还让我有了一个在股票投资方面的从零的突破，为我打开了一扇新世界的大门。”',
  flowHome86: '加州大学圣塔芭芭拉分校 西北大学卡塔尔分校 多伦多大学',
  flowHome87: '“NSL是一次全新的挑战和突破，从来没有想过自己有一天竟然会参加和赛车有关的活动。从队伍0到1 的招新，到第一次尝试商业赞助谈判，又到组织筹办线下分享会……每一次遇到问题，我们从不会放弃，车队一起思考解决办法，调动可用资源来解决问题，这是我们对于 NSL 的执着。”',
  flowHome88: '纽约大学',
  flowHome89: '“当决定要学心理学后，我参加了HOSA，并成为了校园领袖。HOSA的研习过程相比其他生医健相关的学术活动更加有趣，可以和团队成员以及指导老师有很多的互动和交流， 不仅仅帮助我建立了对于心理学的学科信心，我也通过领导学习小组的经验锻炼和提升了个人领导力。”',
  flowHome90: '北卡罗来纳大学教堂山分校',
  flowHome91: '2021-2022 HOSA 学生理事会运营副主席 ',
  flowHome92: '“点燃我STEAM使命感的，带我闯入科学工程大门的，就是NSL。不止是在中国站和全球站现场，而是在整个备战积累的过程中，虽遇到很多不尽人意的困难，但收获了很多的成长，这给我带来了深深的成就感。我期待通过自己的努力，鼓励到女生关于科学工程的学习兴趣，让更多的女孩子可以进入到STEAM领域！”',
  flowHome93: '“当看到NSL这样以赛车为主题的STEAM活动时，从小作为赛车爱好者的我毫不犹豫就加入了。作为摄影爱好者，我会负责拍摄车队的点点滴滴，而由我拍摄剪辑的车队宣传片也非常有幸地被NSL 组委会 Ten80 发布在其官方频道。我结识了来自全国各地不同学校却有着相同爱好的同学并且三言两语就能跟他们聊到一起去，真的很享受这种团队合作的氛围感！”',
  flowHome94: '加州大学圣迭戈分校',
  flowHome95: 'Moses',
  flowHome96: ' Cici',
  flowHome97: 'Viola',
  flowHome98: 'Jasmine',
  flowHome99: 'Bobby',
  flowHome100: 'Engineer from AS',
  flowHome101: '',
  flowHome102: 'Bloom - ',
  flowHome103: '活动经历：SKT-NEC',
  flowHome104: '活动经历： SKT-SIC'
}

export const flowHomeEN = {
  flowHome1: 'Featured',
  flowHome2: ' Recommended',
  flowHome3: '',
  flowHome4: 'Dates',
  flowHome5: 'Y年M月D日',
  flowHome6: 'Grades',
  flowHome7: 'Economics,Finance and Business',
  flowHome8: 'Life and Health Sciences',
  flowHome9: ' Liberal Arts',
  flowHome10: 'Humanities and Social Sciences',
  flowHome11: 'Science and Engineering',
  flowHome12: 'Leadership',
  flowHome13: 'Registering',
  flowHome14: 'SKT Group Activities',
  flowHome15: 'Student Activities',
  flowHome16: 'Others',
  flowHome17: 'Brands of Holistic Education activity',
  flowHome18: 'China Cities',
  flowHome19: 'International schools Partners',
  flowHome20: 'Elite Learners',
  flowHome21: 'Ref：Data from Bloom backend',
  flowHome22: 'Limitless Growth, ',
  flowHome23: 'Infinite Abilities',
  flowHome24: 'Embrace the World, Envision the Future',
  flowHome25: 'Admitted to',
  flowHome26: 'Navigating Challenges',
  flowHome27: ' Through Socialization',
  flowHome28: 'Connecting Peers Through the Enthusiast Community',
  flowHome29: 'Fostering Leadership Through Varied Pathways',
  flowHome30: 'Join ',
  flowHome31: ' Our Activity',
  flowHome32: 'Four Steps To Start Your Journey',
  flowHome33: 'Join',
  flowHome34: 'A Social Learning Activity',
  flowHome35: 'Launched in 2019, Bloom is a self-developed online platform for social learning, aiming at providing solutions for collaborative and social learning to students, study groups, schools, judges, coaches, and activity organizers. It establishes a communication platform for outstanding students nationwide, offering them online and offline learning opportunities to connect academic mentors and industry experts for exploring cutting-edge academic achievements. Bloom provides high-quality courses on developing students’ personality and competency, and also assists students in efficiently completing social projects, referring to collaboration in teamwork, project-based learning, and inquiry-based learning.',
  flowHome36: 'Customizing Your Social Learning Journey',
  flowHome37: 'Exploring an Extensive Library of Learning Resources',
  flowHome38: 'Engaging with an Interactive Online Learning System',
  flowHome39: 'Connecting and Interact with Exceptional Peers',
  flowHome40: 'Gathering',
  flowHome41: ' Global Resources',
  flowHome42: 'Integrating High-Impact Projects',
  flowHome43: `Unleashing Students' Potential`,
  flowHome44: 'Official WeChat Account',
  flowHome45: '粤ICP备2022127116号',
  flowHome46: 'Statement: Students can participate in various skill development activities under SKT through self-study and team study. These activities only provide necessary academic and platform support, and do not provide any training services. The activities only record the process of student study, and evaluate the results comprehensively, without providing any awards or honors. If students need overseas education certifications, they can apply for academic honors recognition through the independent third-party certification organization CP21 (21st Century Talent Standards Alliance) based on the comprehensive evaluation results of students in various skill development activities under SKT, according to the academic standards of relevant authoritative partners. The academic honors recognition results are unrelated to this series of skill development activities and are only applicable to students’ self-certification for overseas education. All activities under SKT are independently recruiting participants and are not jointly recruiting with schools.',
  flowHome47: 'Bloom event platform, discover fun and interesting activities, interesting people',
  flowHome48: 'Trailer',
  flowHome49: `There's still more to come:`,
  flowHome50: 'Livestream time',
  flowHome51: 'Check out more live streams',
  flowHome52: 'Livestreaming:',
  flowHome53: 'Cooperative brands',
  flowHome54: 'Gather global academic resources',
  flowHome55: 'Marks of growth',
  flowHome56: 'Breaking disciplinary boundaries to solve real-world problems',
  flowHome57: 'What students say',
  flowHome58: 'Here they see the world and the future',
  flowHome59: 'Trending news',
  flowHome60: 'Capacity Improvement Plan',
  flowHome61: 'View more',
  flowHome62: 'Recommended activities',
  flowHome63: 'Tens of thousands of middle school students’choice',
  flowHome64: 'Registered activities',
  flowHome65: ' ©Copyright 绽放芯知 版权所有 Powered by 绽放芯知',
  flowHome66: 'Social Learning Platform',
  flowHome67: 'All Live',
  flowHome68: 'Live time',
  flowHome69: 'SKT Group Activities',
  flowHome70: 'Recommended programs',
  flowHome71: 'Mary',
  flowHome72: `My first time writing engineering notes, my first time managing a WeChat official account, my first time designing car shells and posters, and my first time writing a business plan - all these 'firsts' were achieved through my involvement in SKT-NSL. From being a complete novice to mastering these skills, NSL taught me that even in an area I had never ventured into before, I could still nail it. It turned me into someone who dares to try. During my high school years, I made many attempts that contributed to my college applications, and the courage to make these attempts came from NSL.`,
  flowHome73: 'University of California, Berkeley',
  flowHome74: 'Activity Experience: SKT-NSL, SKT-HOSA, SKT-SIC',
  flowHome75: 'Sicheng',
  flowHome76: 'It might seem that in BPA, the grades are decided only by that brief hour of competition, but for me, the lengthy process of preparing and learning business knowledge and skills has been incredibly beneficial. The honor itself is not important; what matters is that during the process, I truly learned how to apply business knowledge in real situations. For instance, my ability to actively participate and propose solutions during summer school sessions is a direct result of the knowledge I gained at the BPA National Conference.',
  flowHome77: 'BPA 2023 Global High School Division, Top 1 in Management, Marketing, and Human Resources Concepts',
  flowHome78: 'Xiaoyi',
  flowHome79: `SKT-HOSA provided me with two unforgettable years of personal growth. I transformed from a student merely interested in biology into a pre-med student, determined to pursue a career in healthcare, and gradually found my professional goals and future direction. SKT-HOSA is not just an academic study activity; it's a warm community and a platform that enlightens medical dreams.`,
  flowHome80: 'University of California, Berkeley',
  flowHome81: 'Activity Experience: SKT-HOSA',
  flowHome82: 'Zhihan',
  flowHome83: `SKT-NEC brought me together with economic comrades from all corners of the world. Initially, I thought SKT-NEC was simply a platform for me to expand my knowledge in economics. However, it wasn't until the application season that I realized the precious companionship of friends, whom I met through SKT-NEC activities, were there for me during my moments of confusion and anxiety.`,
  flowHome84: 'The University of Hong Kong, University of Cambridge',
  flowHome85: `The soft skills crucial for overseas university applications are primarily reflected in activities, honors, and essays. My investment experience with SKT-SIC can be highlighted in the activities section. All things that I learned from SKT-SIC lessons, such as teamwork and leadership, can also be crafted into an essay to potentially impress admissions officers. Participating in SKT-SIC has enhanced my resume, and more importantly, it has also provided me with a breakthrough in stock investment from scratch by opening the door to a new world.`,
  flowHome86: 'University of California, Santa Barbara; Northwestern University in Qatar; University of Toronto',
  flowHome87: `SKT-NSL presented a completely new challenge and breakthrough for me. I never imagined that one day I would participate in a car-racing-related activity. We recruited new members for our team, participated in business sponsorship negotiations for the first time, and organized offline sharing sessions... Every time we faced a problem, we never gave up. The team worked together to brainstorm solutions, mobilizing available resources to tackle these challenges. This is our dedication to SKT-NSL.`,
  flowHome88: 'New York University',
  flowHome89: `After I decided to study psychology, I joined SKT-HOSA and became a campus leader. The study process in SKT-HOSA is more engaging compared to other biomedical and health-related academic activities, and it offers offering numerous interactions and exchanges with team members and mentors. This experience not only helped me build up confidence in psychology as a discipline, but also allowed me to develop and enhance my leadership skills by leading study groups.`,
  flowHome90: 'University of North Carolina at Chapel Hill',
  flowHome91: 'Activity Experience: SKT-HOSA',
  flowHome92: `It was SKT-NSL that ignited my passion for STEAM and opened the doors to science and engineering for me. My journey wasn't just about participating in the national and global stages, but also about the entire preparatory process. Despite facing many frustrating challenges, I’ve also made great progress and gained a profound sense of accomplishment. I look forward to inspiring more girls to develop an interest in science and engineering, and encouraging more young women to enter the field of STEAM!`,
  flowHome93: `When I saw SKT-NSL, a STEAM activity centered around racing, I didn't hesitate to join as I am a racing enthusiast since childhood. As a photography enthusiast, I took on the role of capturing every moment of our team's journey. The promotional video I shot and edited was fortunate enough to be featured on the official channel of the SKT-NSL organizing committee, Ten80. I met students from all over the country with shared interests, and we could easily connect over a few words. I really enjoy our teamwork and friendship!`,
  flowHome94: 'University of California, San Diego',
  flowHome95: 'Moses',
  flowHome96: 'Cici',
  flowHome97: 'Viola',
  flowHome98: 'Jasmine',
  flowHome99: 'Bobby',
  flowHome100: 'Engineer from AS',
  flowHome101: '',
  flowHome102: 'Bloom - ',
  flowHome103: 'Activity Experience: SKT-NEC',
  flowHome104: 'Activity Experience: SKT-SIC'
}



// WEBPACK FOOTER //
// ./src/assets/locale/flow/home.js